<div class="flex flex-col flex-1 w-full h-full">
  <mat-expansion-panel
    class="w-full cursor-default"
    [expanded]="isExpandedByDefault"
    [disabled]="!isExpandable"
    (opened)="onOpen($event)"
    (closed)="onClose($event)"
  >
    <mat-expansion-panel-header
      class="bg-project-600"
      [ngClass]="{
        'hover:cursor-default': !isExpandable,
        'hover:contrast-[1.05]': isExpandable
      }"
      data-testid="header"
      [collapsedHeight]="HEADER_HEIGHT"
      [expandedHeight]="HEADER_HEIGHT"
    >
      <mat-panel-title class="flex space-x-3 text-project-2400">
        <i class="text-inherit icon" [ngClass]="iconClass"></i>
        <h3 class="text-sm text-inherit whitespace-nowrap">{{ title }}</h3>
        <mat-form-field
          class="w-16"
          appearance="outline"
          [floatLabel]="'never'"
          title="Slide Number"
        >
          <input
            matInput
            min="1"
            max="100"
            type="number"
            class="absolute w-full h-full -inset-0.5"
            [formControl]="this.form.controls.order"
            (keydown)="handleInput($event)"
            (click)="handleInput($event)"
            data-testid="slide-number-picker"
          />
        </mat-form-field>
        <button
          *ngIf="isTyping"
          mat-button
          type="button"
          class="text-xs font-semibold h-7 bg-project-4500/60 text-project-300"
          (click)="applySlideOrder($event)"
          mat-raised-button
          data-testid="applySlideButton"
        >
          Apply
        </button>
        <p *ngIf="imgName" data-testid="headerImageName" class="w-56 text-xs break-words">{{ imgName }}</p>
        <div class="flex flex-1"></div>
        <p
          *ngIf="!isDisabled"
          class="flex justify-end text-xs font-semibold min-w-max hover:text-project-500 hover:underline"
          data-testid="removebtn"
          (click)="removeSlide($event)"
        >
          Remove slide
        </p>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="flex-col flex-1" [ngClass]="" data-testid="expandedContent">
      <ng-content select="[expandedContent]"> </ng-content>
      <div class="flex flex-col flex-1 w-full pt-3">
        <app-media-adder
          [sectionImgsFormControl]="form.controls.mainImage"
          [isMainMedia]="false"
          [isSlide]="true"
          [addMediaLabel]="'Add '"
          [isDisabled]="isDisabled"
        >
        </app-media-adder>
      </div>
      <div class="flex flex-col gap-y-[0.3rem] pt-3 flex-1">
        <app-expandable-section-box
          data-testid="contentEditorExpansion"
          [title]="'Body (optional)'"
          [iconClass]="'icon-user'"
          [isExpandedByDefault]="false"
          [isExpandable]="isExpandable"
        >
          <div
            class="flex flex-col gap-y-[0.3rem] py-2 flex-1"
            data-testid="slideBodyComponent"
            id="slideBodyComponent"
            expandedContent
          >
            <app-content-editor
              *ngIf="!(changingSlideOrder$ | async)"
              (handleAfterInit)="setEditorListeners()"
              [sectionFormControl]="form.controls.body"
              [sectionImgsFormControl]="form.controls.inlineImages"
              [sectionVideosFormControl]="form.controls.inlineVideos"
              [isSlide]="true"
              [isDisabled]="isDisabled"
            ></app-content-editor>
          </div>
          <div
            class="flex flex-col flex-1 p-4 space-y-2 empty:py-0"
            notExpandedContent
          ></div>
        </app-expandable-section-box>
      </div>
    </div>
  </mat-expansion-panel>
  <div
    class="flex pb-0 bg-project-2200"
    [ngClass]="{ 'mat-expansion-panel-body': ref.hasChildNodes() }"
    @fadeInOpacity
    data-testid="notExpandedContent"
    *ngIf="!isExpanded"
    (click)="openPanel()"
    #ref
  >
    <ng-content select="[notExpandedContent]"></ng-content>
  </div>
</div>
